import DOMPurify from 'dompurify';

/**
 * PGSS-5758: email and communication text can come from anyone who emails the inbound address, and the cards
 * render it as HTML. Keep plain formatting (paragraphs, line breaks, bold, lists, links) and drop everything that
 * can run code or load something from outside: scripts, event handlers, frames, forms, styles and images.
 */
const OPTIONS = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: ['style', 'img', 'svg', 'math', 'form', 'input', 'button', 'textarea', 'select', 'iframe', 'object',
    'embed', 'link', 'meta', 'base', 'video', 'audio', 'source', 'picture'],
  FORBID_ATTR: ['style', 'srcset', 'background', 'poster'],
};

export default function safeHtml(html) {
  if (html === null || html === undefined) {
    return '';
  }
  return DOMPurify.sanitize(String(html), OPTIONS);
}
